import { translate } from '../../../utils/GameEngine';
import { IconButton } from './IconButton';
import { TextStyles } from '../../../utils/TextStyles';

export class RetryButton extends IconButton {

    constructor(callback?: () => any) {
        super(translate('Retry', true), callback, 'pink_btn_small@2x', true, true, 1);
    }

    protected initProperties(): void {
        super.initProperties();
        this.iconTexture = 'ad_icon@2x';
        this.iconScale = 0.3;
    }
}